import { render, staticRenderFns } from "./CateringStatusLabel.vue?vue&type=template&id=05b7472d&"
import script from "./CateringStatusLabel.vue?vue&type=script&lang=js&"
export * from "./CateringStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports